import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import AuthGuard from 'utils/route-guard/AuthGuard';
import AdminGuard from 'utils/route-guard/AdminGuard';

// render - portal pages
const Dashboard = Loadable(lazy(() => import('pages/dashboard')));
const Customers = Loadable(lazy(() => import('pages/customers')));
const FamiliesPage = Loadable(lazy(() => import('pages/families')));
const FamilyTrials = Loadable(lazy(() => import('pages/family-trials')));
const MaxTrials = Loadable(lazy(() => import('pages/max-trials')));
const Status = Loadable(lazy(() => import('pages/status')));
const Billing = Loadable(lazy(() => import('pages/billing')));
const Settings = Loadable(lazy(() => import('pages/settings')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <DashboardLayout />
    </AuthGuard>
  ),
  children: [
    { path: '/', element: <Navigate to="/dashboard" replace /> },
    { path: 'dashboard', element: <Dashboard /> },
    { path: 'customers', element: <Customers /> },
    { path: 'families', element: <FamiliesPage /> },
    {
      // Administrators only: this page grants Family to a partner's
      // households with no card and creates Stripe invoices for the partner.
      path: 'family-trials',
      element: (
        <AdminGuard>
          <FamilyTrials />
        </AdminGuard>
      )
    },
    {
      // Administrators only: this page issues Max trial codes, and an
      // enterprise code grants Max company-wide with no card.
      path: 'trials',
      element: (
        <AdminGuard>
          <MaxTrials />
        </AdminGuard>
      )
    },
    { path: 'status', element: <Status /> },
    { path: 'billing', element: <Billing /> },
    {
      // Administrators only. The guard sends members back to the dashboard;
      // the page and the settings API each refuse them independently too.
      path: 'settings',
      element: (
        <AdminGuard>
          <Settings />
        </AdminGuard>
      )
    }
  ]
};

export default MainRoutes;
